export const isEmptyValue = (v) =>
    v === null || v === undefined || String(v).trim() === '' || String(v) === 'None';

export const safeParseChildren = (children) => {
    if (Array.isArray(children)) return children;
    if (typeof children === 'string') {
        try {
            const parsed = JSON.parse(children);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    }
    return [];
};

/**
 * Format sponsor response into the shape used by sponsorInfoSlice:
 * { sponsorEntries, childrenEntries, dropoff }
 */
export const formatSponsorData = (data) => {
    const childrenParsed = safeParseChildren(data.children || []);
    const dropoffTimeRaw = data.dropoffTime;
    const dropoffTime = isEmptyValue(dropoffTimeRaw) ? 'N/A' : dropoffTimeRaw;

    const sponsor = {
        'Full Name': data.sponsorName,
        'Phone Number': data.phone,
        'Email Address': data.email,
        'What describes you the best?': data.title,
        'Number of Angels Sponsored': childrenParsed.length,
        'Drop-off Location':
            data.dropoffLocation === 'Abbotsford'
                ? 'Abbotsford: Abby Campus, S Building'
                : data.dropoffLocation === 'Chilliwack'
                    ? 'Chilliwack: CEP Campus, A Building'
                    : '',
        'Wish Dropped off?': data.dropoff,
        'Drop-off Time': dropoffTime,
    };

    return {
        sponsorEntries: Object.entries(sponsor),
        childrenEntries: childrenParsed,
        dropoff: data.dropoff === 'Yes',
    };
};

/**
 * Format parent response into the shape used by parentInfoSlice:
 * { parentEntries, childrenEntries, approved, pickup }
 * childrenEntries is an array of entries (suitable for table rendering)
 */
export const formatParentData = (data) => {
    const childrenParsed = safeParseChildren(data.children || []);
    const pickupTimeRaw = data.pickupTime;
    const pickupTime = isEmptyValue(pickupTimeRaw) ? 'N/A' : pickupTimeRaw;

    const additionalRaw = data.additionalPerson;
    const additional = isEmptyValue(additionalRaw) ? 'N/A' : additionalRaw;

    const parent = {
        'Angel Code': data.parentId,
        'Full Name': data.parentName,
        'UFV Student ID': data.studentId,
        'Phone Number': data.phone,
        'Email Address': data.email,
        'Application Status': data.approved === 'Yes' ? 'Approved' : 'Not Accepted',
        'Pick-up Location':
            data.pickupLocation === 'Abbotsford'
                ? 'Abbotsford: Abby Campus, S Building'
                : data.pickupLocation === 'Chilliwack'
                    ? 'Chilliwack: CEP Campus, A Building'
                    : '',
        'Additional Pick-up Person': additional,
        'Wish Picked Up?': data.pickup,
        'Pick-up Time': pickupTime,
    };

    // map children objects -> array of entry arrays
    const childrenEntries = childrenParsed.map((c) =>
        Object.entries({
            'Angel Code': c.childId,
            'First Name': c.childName,
            Age: c.age,
            Gender: c.gender,
            Wish: c.wish,
        })
    );

    return {
        parentEntries: Object.entries(parent),
        childrenEntries,
        approved: data.approved,
        pickup: data.pickup === 'Yes',
    };
};